import React from 'react';
import debug from 'debug';
import { connect, ConnectedProps } from 'react-redux';
import { TRAVERSE_TREE_TARGETS } from 'client/components/common/BuildingBlocks/utils/common';
import { traverseTree } from 'client/components/common/BuildingBlocks';
import { Context } from 'client/components/common/ResponsiveProvider/Context';
import { BBModel, StorySymbols } from 'types/story';
import { ClientReducerState } from 'client/reducers';

const log = debug('client:components:TreeRenderer');
const { Consumer } = Context;
const defaultProps = {
	// eslint-disable-next-line react/default-props-match-prop-types
	cardElements: [],
	symbols: {},
};

const mapStateToProps = (state: ClientReducerState) => ({
	state: state.editor.state,
	cardElements: state.card.elements,
});

const connector = connect(mapStateToProps);

type Props = ConnectedProps<typeof connector> & {
	// state: EditableStateInfo;
	treeOptions: {
		target?: string;
		isCardTree?: boolean;
		onClick?: (...args: any[]) => any;
		onMouseEnter?: (...args: any[]) => any;
		onMouseLeave?: (...args: any[]) => any;
	};
	elements: BBModel[];
	// cardElements?: BBModel[];
	symbols?: StorySymbols;
};

const TreeRenderer = (props: Props) => {
	const { elements, treeOptions } = props;
	const isEditor = treeOptions.target === TRAVERSE_TREE_TARGETS.EDITOR;
	const extraProps = isEditor ? { state: props.state } : {};

	log(`%c${treeOptions.isCardTree ? 'cardElements' : 'storyElements'}`, 'font-weight: bold');

	return (
		<Consumer>
			{({ mediaQuery, currentMediaQuery }) =>
				traverseTree(elements, {
					...treeOptions,
					...extraProps,
					// @ts-expect-error ts-migrate FIXME
					mediaQuery,
					currentMediaQuery,
					cardElements: props.cardElements,
					symbols: props.symbols,
				})
			}
		</Consumer>
	);
};

TreeRenderer.defaultProps = defaultProps;

function areEqual(prevProps, nextProps) {
	const isElementsEqual = prevProps.elements === nextProps.elements;
	const isSymbolsEqual = prevProps.symbols === nextProps.symbols;
	const isStateEqual =
		Object.keys(nextProps.state.source).some(key => nextProps.state.source[key] === prevProps.state.source[key]) &&
		prevProps.state.state === nextProps.state.state;

	if (!nextProps.treeOptions.isCardTree) {
		const isCardElementsEqual = prevProps.cardElements === nextProps.cardElements;
		return isStateEqual && isElementsEqual && isSymbolsEqual && isCardElementsEqual;
	}

	return isStateEqual && isElementsEqual && isSymbolsEqual;
}

export default connector(React.memo(TreeRenderer, areEqual));
